export function createSafeStyledView(View) {
    // Do nothing by default
    return View;
}
//# sourceMappingURL=createSafeStyledView.js.map